import { Component } from '@angular/core';

@Component({
    selector: 'app-redoc-connect',
    templateUrl: './redoc-connect.component.html',
    styleUrls: ['./redoc-connect.component.scss'],
    standalone: false,
})
export class RedocConnectComponent {}
